$( document ).ready(function() {

    // Nav menu
    $('.site-nav__parent-item--has-children .site-nav__parent-link').click(function(e){
        e.preventDefault();
        e.stopPropagation();
    });

    // Department
    enquire.register("screen and (max-width:849px)", {
        match : function() {
            $('.site-header__dept').prependTo('#menu .mobile-nav');
        },
        unmatch : function() {
            $('.site-header__dept').prependTo('.site-header__inner'); 
        }
    });

    // Mobile filters Open
    $('.mobile-filters-toggle').click(function(e){
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('active')
        $('.collection-product-cards-filters').toggleClass('open');
    });

    // Opens filter group
    $('.collection-product-cards-sidebar .filter-columns .h6').click(function(e){
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('active')
        $(this).siblings('.form-group').toggleClass('form-group--open');
    });

    // Rolling announcements
    function fadeInOut(item) {
        item.slideDown(300).delay(7000).slideUp(300, function() {
        if (item.next().length) // if there is a next element
        {
        fadeInOut(item.next());
        } // use it
        else {
        fadeInOut(item.siblings(':first'));
        } // if not, then use go back to the first sibling
        });
    }
    fadeInOut(jQuery('#rolling div:first-child'));

    // Counts number of active filters and adds as number to button
    var count_filters = $('.menu-filter .collection-tags .tag-chip').length;
    if ($(count_filters).length > 0) {
        $('.collection-filter-button').append(' (' + count_filters + ')');
    }

    $('.ajax-search-header').click(function(e){
        e.preventDefault();
        e.stopPropagation();
    });
    $('.ajax-search-overlay .form-input').click(function(e){
        e.preventDefault();
        e.stopPropagation();
    });

    // Product modal
    $('.show-gallery').click(function(e){
        $('#shopify-section-site-header').addClass('modal-active');
    });
    $('.show-modal-btn').click(function(e){
        $('#shopify-section-site-header').addClass('modal-active');
    });
    $('.size-guide-app-link a').click(function(e){
        $('#shopify-section-site-header').addClass('modal-active');
    });
    $('.modal-overlay').click(function(e){
        $('#shopify-section-site-header').removeClass('modal-active');
    });
    $('.close-gallery').click(function(e){
        $('#shopify-section-site-header').removeClass('modal-active');
    });
    $('.close-modal').click(function(e){
        $('#shopify-section-site-header').removeClass('modal-active');
    });
    $('.modal_close').click(function(e){
        $('#shopify-section-site-header').removeClass('modal-active');
    });
    $('.modal_background').click(function(e){
        $('#shopify-section-site-header').removeClass('modal-active');
    });

    // Hides menus when clicked away
    $(document).click( function(e){
        $('.site-nav__children-list').removeClass('site-nav__children-list--open');
        $('.site-nav__parent-item').removeClass('site-nav__parent-item--active');
        $('.site-nav__parent-list').removeClass('site-nav__parent-list--open');
        $('.ajax-search-overlay').removeClass('show');
    });

    // Smooth scroll and reveal
    // $('a[href^="#"]').on('click',function (e) {
	//     e.preventDefault();
	//     var target = this.hash;
	//     var $target = $(target);
    //     var href = $(this).attr('href').replace('#', '');
	//     $('html, body').stop().animate({
	//         'scrollTop': $target.offset().top
	//     }, 500, 'swing', function () {
	//         window.location.hash = target;
	//     });
    //     $('#' + href).addClass('reveal--open');
	// });
});
